module.exports = __webpack_public_path__ + "img/icon-sb-shop-similar.b1a84f6.svg";